module.exports = require("@pb/kit-hooks-use-resize-observer");